var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-content"},[_c('p',{staticClass:"display-1 font-weight-light mt-12"},[_vm._v("Sorry the page is not found.")]),_c('v-icon',[_vm._v("mdi-emoticon-sad-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }